import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/subscriptions/plans"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const EditSubscription = async (values) => {
    return await axiosInstance(options).put(`${path}/update-subscription-plan`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?_id=${id}`);
}

export const ChangeStatus = async (values) => {
    return await axiosInstance(options).post(`${path}/change-status`, values)
}



